import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  getSeasonRegistry: false,
  getLoginUserTeamsInSeasonRegistries: false,
  updateTeamData: false,
  updateStaffsData: false,
  updatePlayersData: false,
  uploadPDF: false,
  updateReview: false,
};

const TeamInSeasonRegistry = {
  getSeasonRegistry: ({ registryUniqid }) => {
    if (debugStatus.getSeasonRegistry) {
    }

    return ApiService.get(`/api/season_registries/${registryUniqid}`);
  },

  getLoginUserTeamsInSeasonRegistries: () => {
    if (debugStatus.getLoginUserTeamsInSeasonRegistries) {
    }

    return ApiService.get(`/api/season_registries_teams`);
  },

  updateTeamData: ({ registryUniqid, teamInRegistryUniqid, data }) => {
    if (debugStatus.updateTeamData) {
    }

    return ApiService.put(`/api/season_registries/${registryUniqid}/teams/${teamInRegistryUniqid}/team`, { data });
  },

  updateStaffsData: ({ registryUniqid, teamInRegistryUniqid, data }) => {
    if (debugStatus.updateTeamData) {
    }

    return ApiService.put(`/api/season_registries/${registryUniqid}/teams/${teamInRegistryUniqid}/staffs`, { data });
  },

  updatePlayersData: ({ registryUniqid, teamInRegistryUniqid, data }) => {
    if (debugStatus.updatePlayersData) {
    }

    return ApiService.put(`/api/season_registries/${registryUniqid}/teams/${teamInRegistryUniqid}/players`, { data });
  },

  uploadPDF: ({ registryUniqid, teamInRegistryUniqid, data }) => {
    if (debugStatus.uploadPDF) {
    }

    return ApiService.put(`/api/season_registries/${registryUniqid}/teams/${teamInRegistryUniqid}/pdf`, { data });
  },

  updateReview: ({ registryUniqid, teamInRegistryUniqid, data }) => {
    if (debugStatus.updateReview) {
    }

    return ApiService.put(`/api/season_registries/${registryUniqid}/teams/${teamInRegistryUniqid}/review`, { data });
  },
};

export default TeamInSeasonRegistry;
